import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../http";
import type { LLM } from "@/lib/types/secure-llm";

async function getLlms() {
  return await api.governance.get<Array<LLM>>("llms");
}

export const llmsQueryOptions = queryOptions({
  queryKey: ["secure-llm", "llms"],
  async queryFn() {
    const res = await getLlms();
    const data = await res.json();
    return { res, data };
  },
  select(data) {
    return data.data;
  },
});

export function useLlms() {
  return useQuery(llmsQueryOptions);
}
